<div class="info-bar">
  <p fxLayoutAlign="start center" fxLayoutGap="24px" class="info-bar--content">
    <mat-icon [svgIcon]="infoType" [ngClass]="infoType"></mat-icon>
    <span>{{ text }}</span>
  </p>
</div>
